import EditItemDropdown from "../EditItemDropdown";
import ReanalyseCompetenceResultsDropdownAction, {
  Props as ReanalyseCompetenceResultsDropdownActionProps,
} from "./dropdown-actions/ReanalyseCompetenceResultsDropdownAction";
import ReportSaveDropdownAction, {
  Props as ReportSaveDropdownActionProps,
} from "./dropdown-actions/ReportSaveDropdownAction";

type Props = {
  reportSaveProps: ReportSaveDropdownActionProps;
  reanalyseCompetenceResultsProps: ReanalyseCompetenceResultsDropdownActionProps;
};

export default function ResultsDropdown({reportSaveProps, reanalyseCompetenceResultsProps}: Props) {
  return (
    <EditItemDropdown>
      <ReportSaveDropdownAction {...reportSaveProps} />
      <ReanalyseCompetenceResultsDropdownAction {...reanalyseCompetenceResultsProps} />
    </EditItemDropdown>
  );
}
